import Uppy from '@uppy/core';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import Tus from '@uppy/tus';
import { env } from 'next-runtime-env';

const endpoint = `${env('ASSET_UPLOAD_ENDPOINT')}`;

const restrictions = {
  allowedFileTypes: ['image/*', 'video/mp4', 'video/quicktime', 'video/mov'],
};
const onBeforeFileAdded = () => true;

let uppy: Uppy | undefined = undefined;

export const getUppy = () => {
  if (!uppy) {
    uppy = new Uppy({
      id: 'uppy1',
      autoProceed: true,
      debug: true,
      restrictions,
      onBeforeFileAdded,
    }).use(Tus, {
      endpoint,
      withCredentials: true,
    });
    uppy.use(ThumbnailGenerator);
  }

  return uppy;
};

export const getMediaPath = (path?: string) => {
  // uploadUrl comes back looking like this: https://upload.dev.vee.com/files/media%2F5ed30428-7a1c-4f5a-a17f-913558ec7421.bmp
  // we need to take the part after the last slash and decode it and use that as the mediaId, in this case: media/5ed30428-7a1c-4f5a-a17f-913558ec7421.bmp
  let mediaId = null;
  if (path) {
    const splitPath = (path || '').split(endpoint);
    if (splitPath.length > 1) {
      mediaId = decodeURIComponent(splitPath[1]);
    }
  }

  return mediaId;
};

export const imageExtensions = [
  '.ai', // adobe illustrator
  '.bmp',
  '.gif',
  '.ico',
  '.jpeg',
  '.jpg',
  '.png',
  '.ps',
  '.psd',
  '.svg',
  '.tif',
  '.tiff',
  '.webp',
];

export const videoExtensions = [
  '.3g2', // - 3GPP2 multimedia file
  '.3gp', // - 3GPP multimedia file
  '.avi', // - AVI file
  '.flv', // - Adobe Flash file
  '.h264', // - H.264 video file
  '.m4v', // - Apple MP4 video file
  '.mkv', // - Matroska Multimedia Container
  '.mov', // - Apple QuickTime movie file
  '.mp4', // - MPEG4 video file
  '.mpg', // or .
  '.mpeg', // - MPEG video file
  '.rm', // - RealMedia file
  '.swf', // - Shockwave flash file
  '.vob', // - DVD Video Object
  '.webm', // - WebM video file.
  '.wmv', // - Windows Media Video file
];
